/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable react/jsx-props-no-spreading */
import {
  makeStyles,
  createStyles,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Typography,
  Avatar,
  StepConnector,
  withStyles,
  Grid
} from "@material-ui/core";
import React, { useMemo } from "react";

const editIcon = require("../../images/Edit_white.svg");

const AuditStepperStyles = makeStyles(() =>
  createStyles({
    root: {
      minWidth: "360px",
      maxWidth: "400px"
    },
    editIcon: {
      width: 16,
      height: 16
    },
    contentWrapper: {
      marginTop: "-24px"
    }
  })
);

const AuditCardStyles = makeStyles(() =>
  createStyles({
    text1: {
      fontSize: "12px",
      color: "#32325d",
      wordBreak: "break-all",
      fontWeight: "normal"
    },
    text11: {
      fontWeight: 600
    },
    initialAvatar: {
      width: "28px",
      height: "28px",
      fontSize: "14px",
      fontWeight: 600,
      backgroundColor: "#9d5ce6"
    },
    userTypeAvatar: {
      width: "15px",
      height: "15px",
      fontSize: "13px",
      fontWeight: "bold"
    },
    text2: {
      fontSize: "10px",
      color: "#5b6880",
      wordBreak: "break-word"
    }
  })
);

const QontoConnector = withStyles({
  line: {
    borderColor: "#5566d6",
    borderTopWidth: 3,
    borderRadius: 1
  },
  vertical: {
    padding: "0px"
  }
})(StepConnector);

const CustomStepContent = withStyles({
  root: {
    marginTop: "0px",
    borderLeftWidth: "2px",
    marginLeft: "11px",
    borderColor: "#5566d6"
  }
})(StepContent);

export interface AuditCardProps {
  preValue?: string;
  currValue: string;
  firstName: string;
  lastName: string;
  reason?: string;
  updatedDate: string; // moment().format("Do MMM YYYY, hh:mm:ss")
  createdByConfig?: {
    style: any;
    label: string;
  };
}

const AuditCard = (props: AuditCardProps) => {
  const classes = AuditCardStyles();
  const {
    preValue,
    currValue,
    reason,
    firstName,
    lastName,
    updatedDate,
    createdByConfig
  } = props;

  const { initials, userName } = useMemo(() => {
    let inits: string = "";
    let userN: string = "";
    if (firstName) {
      inits += firstName.charAt(0);
      userN += firstName;
    }
    if (lastName) {
      inits += lastName.charAt(0);
      userN += ` ${lastName}`;
    }
    return { initials: inits, userName: userN };
  }, [firstName, lastName]);

  return (
    <Grid container direction="column">
      {preValue && (
        <Grid item>
          <Typography className={classes.text1} component="p">
            <span className={classes.text11}>Previous Value : </span>
            {preValue}
          </Typography>
        </Grid>
      )}
      <Grid item>
        <Typography className={classes.text1} component="p">
          <span className={classes.text11}>Edited Value : </span>
          {currValue}
        </Typography>
      </Grid>
      {reason && (
        <Grid item>
          <Typography className={classes.text1} component="p">
            <span className={classes.text11}>Reason : </span>
            {reason}
          </Typography>
        </Grid>
      )}
      <Grid item style={{ paddingTop: "10px" }}>
        <Grid container alignItems="center" wrap="nowrap">
          <Grid item>
            <Avatar className={classes.initialAvatar}>{initials}</Avatar>
          </Grid>
          <Grid item className={classes.text2} style={{ padding: "0px 5px" }}>
            {userName}
          </Grid>
          <Grid item className={classes.text2}>
            •
          </Grid>
          <Grid item style={{ padding: "0px 5px" }}>
            <Avatar
              className={classes.userTypeAvatar}
              style={createdByConfig?.style}
            >
              {createdByConfig?.label}
            </Avatar>
          </Grid>
          <Grid item className={classes.text2}>
            •
          </Grid>
          <Grid item className={classes.text2} style={{ padding: "0px 5px" }}>
            {updatedDate}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export const AuditHistory = (props: { auditList: AuditCardProps[] }) => {
  const { auditList } = props;
  const classes = AuditStepperStyles();

  const editIconVar = (
    <Avatar style={{ width: "24px", height: "24px", background: "#5566d6" }}>
      <img src={editIcon} className={classes.editIcon} alt="history-edit" />
    </Avatar>
  );

  return (
    <div className={classes.root}>
      <Stepper
        orientation="vertical"
        connector={<QontoConnector />}
        style={{
          borderRadius: "6px",
          boxShadow: "0 2px 12px 0 rgba(50, 50, 93, 0.21)"
        }}
      >
        {auditList.map((auditData: AuditCardProps) => {
          return (
            <Step active>
              <StepLabel icon={editIconVar} />
              <CustomStepContent>
                <div className={classes.contentWrapper}>
                  <AuditCard {...auditData} />
                </div>
              </CustomStepContent>
            </Step>
          );
        })}
      </Stepper>
    </div>
  );
};
